import { useEffect, useState } from 'react';
import { Menu, MessageSquare, History, LogIn, LogOut } from 'lucide-react';
import { Button } from './ui/button';
import { supabase } from '@/integrations/supabase/client';
import { useNavigate } from 'react-router-dom';

export const Header = () => {
  const [session, setSession] = useState<any>(null);
  const [activeView, setActiveView] = useState<'chat' | 'history'>('chat');
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/auth');
  };

  return (
    <header className="h-12 bg-card border-b border-border flex items-center justify-between px-4">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" className="icon-button">
          <Menu className="h-5 w-5" />
        </Button>
        <div className="flex gap-2">
          <Button
            variant={activeView === 'chat' ? 'secondary' : 'ghost'}
            size="sm"
            onClick={() => setActiveView('chat')}
            className="flex items-center gap-2"
          >
            <MessageSquare className="h-4 w-4" />
            Чат
          </Button>
          <Button
            variant={activeView === 'history' ? 'secondary' : 'ghost'}
            size="sm"
            onClick={() => setActiveView('history')}
            className="flex items-center gap-2"
          >
            <History className="h-4 w-4" />
            История
          </Button>
        </div>
      </div>
      
      <div className="text-lg font-semibold">Project Name</div>
      
      <div className="flex items-center gap-2">
        {session ? (
          <>
            <span className="text-sm text-muted-foreground">{session.user.email}</span>
            <Button
              variant="ghost"
              size="icon"
              onClick={handleLogout}
              className="icon-button"
            >
              <LogOut className="h-5 w-5" />
            </Button>
          </>
        ) : (
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate('/auth')}
            className="icon-button"
          >
            <LogIn className="h-5 w-5" />
          </Button>
        )}
      </div>
    </header>
  );
};